export enum SupportedLanguages {
  EN = 'en',
  IT = 'it',
  ZH = 'zh',
}

export const DefaultLanguage = SupportedLanguages.EN;
